import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import _isNil from 'lodash/isNil';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import Content from '../../atoms/Content';

// Containers
import makeCellRenderer from './makeCellRenderer';

// Constants
import { EMPTY_PLACEHOLDER } from './cellRenderer.constants';
var TextRenderer = /*#__PURE__*/function (_PureComponent) {
  _inherits(TextRenderer, _PureComponent);
  var _super = _createSuper(TextRenderer);
  function TextRenderer() {
    _classCallCheck(this, TextRenderer);
    return _super.apply(this, arguments);
  }
  _createClass(TextRenderer, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        data = _this$props.data,
        placeHolder = _this$props.placeHolder,
        className = _this$props.className,
        contentClassName = _this$props.contentClassName,
        column = _this$props.column,
        highlight = _this$props.highlight,
        style = _this$props.style;
      return /*#__PURE__*/React.createElement("div", {
        className: className,
        style: style
      }, /*#__PURE__*/React.createElement(Content, {
        highlight: highlight,
        className: contentClassName,
        id: column.id
      }, _isNil(data) ? placeHolder : data));
    }
  }]);
  return TextRenderer;
}(PureComponent);
TextRenderer.propTypes = {
  data: PropTypes.string,
  // eslint-disable-line
  placeHolder: PropTypes.string,
  className: PropTypes.string,
  contentClassName: PropTypes.string,
  column: PropTypes.object,
  style: PropTypes.object
};
TextRenderer.defaultProps = {
  placeHolder: EMPTY_PLACEHOLDER,
  className: '',
  contentClassName: '',
  column: EMPTY_OBJECT,
  style: EMPTY_OBJECT
};
export { TextRenderer };
export default makeCellRenderer(TextRenderer);